// Per-app admin configuration for material categories.
// Single source of truth for which categories each app sees and what
// materialType string the backend uses to filter beam/cross-section templates.

export type AppMaterial = 'concrete' | 'wood' | 'steel'
export type MaterialCategory = 'steel' | 'concrete' | 'timber' | 'reinforcement' | 'prestressing'

// Concrete carries reinforcement + prestressing because both are concrete-only
// concepts (see project memory: PT/prestressing is concrete-only).
export const ALLOWED_MATERIAL_CATEGORIES: Record<AppMaterial, readonly MaterialCategory[]> = {
  concrete: ['concrete', 'reinforcement', 'prestressing'],
  wood: ['timber'],
  steel: ['steel']
}

export const TEMPLATE_MATERIAL_TYPE: Record<AppMaterial, string> = {
  concrete: 'concrete',
  wood: 'timber',
  steel: 'steel'
}
